export function normalizeSearchInput(term: string): string {
  return term.trim().replace(/\s+/g, ' ');
}

export function tokenize(term: string): string[] {
  const normalized = normalizeSearchInput(term).toLowerCase();
  if (!normalized) return [];
  return normalized.split(' ').filter(Boolean);
}

export function escapeIlikeToken(token: string): string {
  return token
    .trim()
    .replace(/[(),]/g, ' ')
    .replace(/\s+/g, ' ')
    .replace(/[%_]/g, '\\$&')
    .trim();
}

export function isLikelyUuid(token: string): boolean {
  return /^[0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$/i.test(token);
}

export function matchesAllTokens(recordTextParts: Array<unknown>, tokens: string[]): boolean {
  if (tokens.length === 0) return true;

  const parts = recordTextParts
    .map((part) => (part == null ? '' : String(part).toLowerCase()))
    .filter(Boolean);

  if (parts.length === 0) return false;

  return tokens.every((token) => parts.some((part) => part.includes(token)));
}
